import { createContext } from "react";
import { FuseNavItemType } from "@fuse/core/FuseNavigation/types/FuseNavItemType";

export type HeaderTab = {
	id: string;
	title: string;
	url: string;
};

export type HeaderTabsContextType = {
	tabs: HeaderTab[];
	activeTabId: string | null;
	openFromNavItem: (item: FuseNavItemType) => void;
	setActiveTab: (id: string) => void;
	closeTab: (id: string) => void;
	clearAllTabs: () => void;
};

export const HeaderTabsContext = createContext<HeaderTabsContextType | undefined>(undefined);
